import Header from "../components/Header";
import Footer from "../components/Footer";
import PageBanner from "../components/PageBanner";

function PrivacyPolicy() {
  return (
    <div className="bg-white min-h-screen">
      <Header />

      <PageBanner
        title="Privacy Policy"
        subtitle="Learn how we protect and handle your personal information."
        image="https://images.unsplash.com/photo-1563013544-824ae1b704d3?auto=format&fit=crop&w=1920&q=80"
      />

      <main className="max-w-7xl mx-auto px-6 py-20">
        <div className="bg-white rounded-lg shadow-lg p-8 prose prose-gray max-w-none">
          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Introduction</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            At MyTrip4U, we are committed to protecting your privacy and ensuring the security of your personal information.
            This Privacy Policy explains how we collect, use, and safeguard your data when you use our website and services.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Information We Collect</h2>
          <h3 className="text-xl font-medium mb-4 text-gray-700">Personal Information</h3>
          <p className="mb-4 text-gray-600 leading-relaxed">
            When you contact us through our forms, we may collect:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-600">
            <li>Name and contact information (email, phone number)</li>
            <li>Address and location data</li>
            <li>Messages and inquiries you send us</li>
          </ul>

          <h3 className="text-xl font-medium mb-4 text-gray-700">Technical Information</h3>
          <p className="mb-4 text-gray-600 leading-relaxed">
            We automatically collect certain technical information when you visit our site:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-600">
            <li>IP address and location data</li>
            <li>Browser type and version</li>
            <li>Device information</li>
            <li>Pages visited and time spent on our site</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">How We Use Your Information</h2>
          <p className="mb-4 text-gray-600 leading-relaxed">
            We use the information we collect to:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-600">
            <li>Respond to your inquiries and provide customer support</li>
            <li>Improve our services and website functionality</li>
            <li>Send you relevant information about our services</li>
            <li>Ensure the security and proper functioning of our website</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Information Sharing</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            We do not sell, trade, or rent your personal information to third parties. We may share your information only in the following circumstances:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-600">
            <li>With your explicit consent</li>
            <li>To comply with legal obligations</li>
            <li>To protect our rights and prevent fraud</li>
            <li>With trusted service providers who assist in our operations (under strict confidentiality agreements)</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Data Security</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. This includes encryption, secure servers, and regular security audits.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Your Rights</h2>
          <p className="mb-4 text-gray-600 leading-relaxed">
            You have the right to:
          </p>
          <ul className="list-disc pl-6 mb-6 text-gray-600">
            <li>Access the personal information we hold about you</li>
            <li>Request correction of inaccurate information</li>
            <li>Request deletion of your personal information</li>
            <li>Object to or restrict certain types of processing</li>
            <li>Data portability</li>
          </ul>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Cookies and Tracking</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie settings through your browser preferences.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Third-Party Services</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            Our website may contain links to third-party websites or integrate with third-party services. We are not responsible for the privacy practices of these external sites. We encourage you to review their privacy policies.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Children's Privacy</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            Our services are not intended for children under 13 years of age. We do not knowingly collect personal information from children under 13.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Changes to This Policy</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            We may update this Privacy Policy from time to time. We will notify you of any significant changes by posting the new policy on this page and updating the "Last Updated" date.
          </p>

          <h2 className="text-2xl font-semibold mb-6 text-gray-800">Contact Us</h2>
          <p className="mb-6 text-gray-600 leading-relaxed">
            If you have any questions about this Privacy Policy or our data practices, please contact us through our contact form or email us directly.
          </p>

          <p className="text-sm text-gray-500 mt-8">
            Last Updated: March 2026
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;